module.exports = __webpack_public_path__ + "img/avatar_random_20.04742bfa.png";